interface PersonalInfoProps {
  formData: any;
  updateFormData: (field: string, value: string) => void;
}

export default function PersonalInfo({ formData, updateFormData }: PersonalInfoProps) {
  return (
    <section className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
          <i className="ri-user-line text-emerald-600 text-xl"></i>
        </div>
        <h2 className="text-xl font-semibold text-slate-800">Kişisel Bilgiler</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* İsim */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            İsim <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={(e) => updateFormData('firstName', e.target.value)}
            required
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="İsminizi giriniz"
          />
        </div>

        {/* Soyisim */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Soyisim <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={(e) => updateFormData('lastName', e.target.value)}
            required
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="Soyisminizi giriniz"
          />
        </div>

        {/* Cinsiyet */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Cinsiyet
          </label>
          <select
            name="gender"
            value={formData.gender}
            onChange={(e) => updateFormData('gender', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm cursor-pointer"
          >
            <option value="">Seçiniz</option>
            <option value="Erkek">Erkek</option>
            <option value="Kadın">Kadın</option>
            <option value="Belirtmek İstemiyorum">Belirtmek İstemiyorum</option>
          </select>
        </div>

        {/* Doğum Tarihi */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Doğum Tarihi
          </label>
          <input
            type="date"
            name="birthDate"
            value={formData.birthDate}
            onChange={(e) => updateFormData('birthDate', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm cursor-pointer"
          />
        </div>

        {/* Medeni Durum */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Medeni Durum
          </label>
          <select
            name="maritalStatus"
            value={formData.maritalStatus}
            onChange={(e) => updateFormData('maritalStatus', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm cursor-pointer"
          >
            <option value="">Seçiniz</option>
            <option value="Evli">Evli</option>
            <option value="Bekar">Bekar</option>
          </select>
        </div>

        {/* Çocuk Sayısı */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Çocuk Sayısı
          </label>
          <select
            name="childrenCount"
            value={formData.childrenCount}
            onChange={(e) => updateFormData('childrenCount', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm cursor-pointer"
          >
            <option value="">Seçiniz</option>
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4+">4+</option>
          </select>
        </div>

        {/* Çocuk Yaş Aralığı */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Çocuk Yaş Aralığı
          </label>
          <select
            name="childrenAge"
            value={formData.childrenAge}
            onChange={(e) => updateFormData('childrenAge', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm cursor-pointer"
          >
            <option value="">Seçiniz</option>
            <option value="0-5 yaş">0-5 yaş</option>
            <option value="6-12 yaş">6-12 yaş</option>
            <option value="13-18 yaş">13-18 yaş</option>
            <option value="18+ yaş">18+ yaş</option>
            <option value="Karışık">Karışık</option>
          </select>
        </div>

        {/* Meslek */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Meslek
          </label>
          <input
            type="text"
            name="occupation"
            value={formData.occupation}
            onChange={(e) => updateFormData('occupation', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="Mesleğinizi giriniz"
          />
        </div>

        {/* Çalıştığı Firma */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Çalıştığı Firma
          </label>
          <input
            type="text"
            name="company"
            value={formData.company}
            onChange={(e) => updateFormData('company', e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
            placeholder="Firma adını giriniz"
          />
        </div>
      </div>
    </section>
  );
}
